export type {
  ZeptoTypeAhead,
  ZeptoTypeAheadOption,
  ZeptoTypeAheadHeaderProps,
  ZeptoTypeAheadActivateMode,
  ZeptoTypeAheadPosition,
  ZeptoTypeAheadWidgetState,
} from "./types";

import { Typeahead } from "./components/Typeahead";
export default Typeahead;
